/* eslint-disable @angular-eslint/prefer-standalone */
import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'document',
  standalone: false
})
@Injectable({
  providedIn: 'root'
})
export class DocumentPipe implements PipeTransform {
  transform(value: number | string, lang?: string): string {
    lang = lang === undefined ? navigator.language : lang;

    let document = value + '';
    /*Alguns paises dependem de informações externas para poder formatar o documento corretamente*/
    switch (lang) {
      case 'pt-BR':
        return this.transformCNPJCPF(document);
      case 'es-BO':
        /*NIT - Bolivia*/
        document = document.replace(/\D/g, '');
        return document
          ? document.replace(/(\d{3})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3-$4')
          : document;
      case 'es-CL':
        /*RUT - Chile*/
        return document
          ? document.replace(/(\w{2})(\d{3})(\d{3})(\w{1})/, '$1.$2.$3-$4')
          : document;
      case 'es-UY':
        /*RUC - Uruguai*/
        document = document.replace(/\D/g, '');
        return document
          ? document.replace(/(\d{2})(\d{6})(\d{4})/, '$1-$2-$3')
          : document;
      case 'es-VE':
        /*RIF - Venezuela*/
        return document
          ? document.replace(/(\w{1})(\d{8})(\d{1})/, '$1-$2-$3')
          : document;
      case 'en-US':
        /*EUA - Fed. Id / SS*/
        return document
          ? document.replace(/(\w{3})(\w{2})(\w{4})/, '$1-$2-$3')
          : document;
      case 'ru-RU':
        /*RNC - Russia*/
        document = document.replace(/\D/g, '');
        return document
          ? document.replace(/(\d{1})(\d{2})(\d{5})(\d{1})/, '$1-$2-$3-$4')
          : document;
      default:
        return document;
    }
  }
  /*CNPJ / CPF - Brasil*/
  transformCNPJCPF(document: string): string {
    if (document === '****') {
      return document;
    }

    document = document.replace(/\D/g, '');

    switch (document.length) {
      case 11:
        return document.replace(/(\d+)(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      case 14:
        return document.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
          '$1.$2.$3/$4-$5'
        );
      default:
        return document;
    }
  }
}
